export const convertSaveCardObject = (data: Record<string, unknown>): Record<string, unknown> => {
  return {
    ...data,
  };
};
